export const Envs = {
  SERVER: process.env.REACT_APP_SERVER || "localhost:3004",
  API_BASE: process.env.REACT_APP_API_BASE || "",
};
